/** Defines icon visuals for each Dialog status. */
export const dialogStatusMapping = {
    danger: {
        iconProps: {
            color: 'red.80',
            name: 'falExclamationTriangle'
        }
    },
    error: {
        iconProps: {
            color: 'red.80',
            name: 'falTimesCircle'
        }
    },
    info: {
        iconProps: {
            color: 'blue.80',
            name: 'falInfoCircle'
        }
    },
    warning: {
        iconProps: {
            color: 'yellow.90',
            name: 'falExclamationTriangle'
        }
    }
};
export const containerId = 'vui-dynamic-container';
export const modalClass = 'vui-modal';
